import clsx from 'clsx';
import format from 'date-fns/format';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './TimestampAndTimelapse.module.scss';
import Timelapse from '../Timelapse';

interface Props {
  timestamp: string | undefined;
}

const TimestampAndTimelapse: React.FC<Props> = ({ timestamp }) => {
  const intl = useIntl();
  if (timestamp) {
    return (
      <div className={styles.timestamp}>
        <div>{format(new Date(timestamp), 'yyyy-MM-dd HH:mm:ss')}</div>
        <Timelapse timestamp={timestamp} />
      </div>
    );
  }

  return (
    <div className={clsx(styles.noMapping, styles.timestamp)}>
      {intl.formatMessage({ id: 'dataManagement.dataQuality.noMapping' })}
    </div>
  );
};

export default TimestampAndTimelapse;
